document.addEventListener("DOMContentLoaded", function() {
  const quantityInputs = document.querySelectorAll('.js-qty__num');

  quantityInputs.forEach(function(input) {
    input.addEventListener("input", function(event) {
      const inputValue = input.value;

      // Use regular expression to allow only numbers
      const regex = /^[0-9]*$/;

      if (!regex.test(inputValue)) {
        // Clear input if it contains non-numeric characters
        input.value = inputValue.replace(/\D/g, '');
      }
    });
  });
});